import React, { useState } from 'react';
import styles from './FaqSection.module.css'; // Import CSS Module

const faqsData = [
    {
        id: 1,
        question: "What Services do you provide?",
        answer: `
            <ul>
                <li>Branding and Positioning</li>
                <li>Offline Designs Production (Brochures, Pamphlets, Business Cards, etc)</li>
                <li>Content & Video Development</li>
                <li>Search Engine Optimization</li>
                <li>Photography and Videography</li>
                <li>Website & App - Design & Development</li>
                <li>Influencer Marketing</li>
                <li>Social Media Marketing</li>
                <li>Paid Search Ads (PPC)</li>
            </ul>
        `
    },
    {
        id: 2,
        question: "What Industries do you work in?",
        answer: `
            <p>Well, experience does account for something after all! Ever since our inception as a full-service digital marketing agency in Pitampura, Delhi, we have gained extensive expertise and knowledge in Real Estate and Hospitality Sector. We offer digital marketing services for healthcare, real estate, fashion, pharma, education, and pretty much all industries under the roof.</p>
            <p>Not from any of these industries? Well, we love a new challenge!</p>
        `
    },
    {
        id: 3,
        question: "Marketing Packages cost?",
        answer: `
            <p>No two projects are the same, and hence, no pricing is the same. We set the pricing for each digital marketing service based on the project. We prepare a customised plan according to the goal. and the estimated time, effort, and expected results.</p>
        `
    },
     {
        id: 4,
        question: "Where are you located?",
        answer: `
            <p>We welcome the doors to our headquarters in Pitampura, Delhi (Near Netaji Subhash Palace).</p>
            <p>Let’s discuss how we can get your business Savvy like us!</p>
        `
    }
];


function FaqSection() {
    const [openFaqId, setOpenFaqId] = useState(null);

    const toggleFaq = (id) => {
        setOpenFaqId(openFaqId === id ? null : id);
    };

    return (
        <div className={styles.faqSection}>
            <div className={styles.faqHeader}>
                <h2 className={styles.faqTitleHindi}>#गहराइयाँ</h2>
                <h3 className={styles.faqTitleMain}>FAQ's</h3>
            </div>

            <div className={styles.faqList}>
                {faqsData.map((faq) => (
                    <div className={styles.faqItem} key={faq.id}>
                        <button
                            className={`${styles.faqQuestion} ${openFaqId === faq.id ? styles.active : ''}`}
                            onClick={() => toggleFaq(faq.id)}
                            aria-expanded={openFaqId === faq.id}
                            aria-controls={`faq-answer-${faq.id}`}
                        >
                            <span>{faq.question}</span>
                            <span 
                                className={`${styles.faqToggleIcon} ${openFaqId === faq.id ? styles.open : ''}`} 
                                aria-hidden="true"
                            >
                            </span>
                        </button>
                        <div
                            id={`faq-answer-${faq.id}`}
                            // Apply faqAnswer style and open style conditionally
                            className={`${styles.faqAnswer} ${openFaqId === faq.id ? styles.open : ''}`}
                            dangerouslySetInnerHTML={{ __html: faq.answer }}
                        >
                        </div>
                    </div>
                ))}
            </div>

            {/* <a href="#" className={styles.loadMoreFaqs}>
                Load More FAQs →
            </a> */}

            <div className={styles.ctaSection}>
                <p className={styles.ctaText}>
                    Now that you've scrolled to the bottom of the page, we'd love to
                    translate this conversion into a conversation.
                </p>
                <p className={styles.ctaSubtext}>Let's talk!</p>
                <a href="/contact" className={styles.ctaButton}>
                    Contact Us
                </a>
            </div>

            <img
                src=''
                alt="" // Decorative images can have empty alt
                className={styles.ctaDecoration}
                aria-hidden="true"
             />
        </div>
    );
}

export default FaqSection;